var map = {
	"./acordo.svg": "6fbc",
	"./agenda.svg": "eec6",
	"./ajuda.svg": "fa95",
	"./alterar.svg": "b645",
	"./ambientes.svg": "d849",
	"./anexo.svg": "8556",
	"./area-texto.svg": "0b7a",
	"./arroba.svg": "5027",
	"./atendimento.svg": "493c",
	"./atualizar.svg": "b90d",
	"./banco.svg": "da2f",
	"./cadeado.svg": "fd74",
	"./calendario.svg": "ac27",
	"./camera-fp.svg": "2d4c",
	"./camera.svg": "6420",
	"./cancelar.svg": "b75f",
	"./cartao.svg": "afa2",
	"./carteira-entrada.svg": "737a",
	"./carteira-saida.svg": "b66f",
	"./carteira.svg": "977e",
	"./celular.svg": "2f3d",
	"./cep.svg": "b55f",
	"./check.svg": "d856",
	"./checklist.svg": "15ad",
	"./chrome.svg": "b1e1",
	"./cifrao.svg": "5040",
	"./clientes.svg": "7257",
	"./codigo-barras.svg": "efb4",
	"./cofre.svg": "26ec",
	"./combobox.svg": "50a3",
	"./configuracoes.svg": "9ce3",
	"./conteudo.svg": "95a8",
	"./copiar.svg": "f211",
	"./correto.svg": "6af2",
	"./csv.svg": "31b1",
	"./dashboard.svg": "ae94",
	"./definir-empresa.svg": "acd5",
	"./deslogar.svg": "a1c0",
	"./dinheiro.svg": "f1ee",
	"./documento-aprovado.svg": "e0d0",
	"./download.svg": "cfa1",
	"./draggable.svg": "0be4",
	"./duplicar.svg": "cf48",
	"./editar.svg": "3e1a",
	"./email.svg": "0a8e",
	"./empresa.svg": "21a8",
	"./entregas.svg": "995b",
	"./enviar.svg": "01c0",
	"./estoque.svg": "51c3",
	"./estrela.svg": "dc18",
	"./excel.svg": "cffd",
	"./excluir.svg": "84e3",
	"./exportar.svg": "5a53",
	"./favorito.svg": "0805",
	"./filtro.svg": "afd2",
	"./fique-por-dentro.svg": "fd16",
	"./foto.svg": "d02d",
	"./grafico.svg": "149a",
	"./historico.svg": "4491",
	"./home.svg": "2daa",
	"./imagem.svg": "6ea4",
	"./imprimir.svg": "343b",
	"./informacao-campo.svg": "cf8b",
	"./informacoes-fp.svg": "cf86",
	"./informacoes.svg": "b1d8",
	"./integracoes.svg": "e44c",
	"./investimento.svg": "4741",
	"./left-circle.svg": "fde9",
	"./mais.svg": "bda7",
	"./menu-max.svg": "d0db",
	"./menu-min.svg": "603e",
	"./meu-negocio.svg": "a97e",
	"./meus-dados.svg": "7150",
	"./navegacao-anterior.svg": "0976",
	"./navegacao-primeiro.svg": "4646",
	"./navegacao-proximo.svg": "fa12",
	"./navegacao-ultimo.svg": "7499",
	"./notificacao.svg": "4bd4",
	"./novo.svg": "c531",
	"./numero.svg": "7299",
	"./ordem-crescente.svg": "558e",
	"./ordem-decrescente.svg": "7c0d",
	"./ordenar-lista.svg": "acb8",
	"./pagamentos.svg": "3e6f",
	"./pdf.svg": "cde3",
	"./pedidos.svg": "289f",
	"./personalizacoes.svg": "d3a9",
	"./pesquisar.svg": "4360",
	"./play.svg": "a5a1",
	"./precificacao.svg": "4970",
	"./procure-aqui.svg": "0cb6",
	"./produto-detalhe.svg": "87bc",
	"./produtos.svg": "c4af",
	"./receita-federal.svg": "0120",
	"./registro-atividades.svg": "ea80",
	"./relogio.svg": "1f39",
	"./remover.svg": "6b89",
	"./right-circle.svg": "d049",
	"./saco-de-dinheiro.svg": "b3f04",
	"./salvar-personalizacoes.svg": "e449",
	"./salvar.svg": "2e21",
	"./scan.svg": "6786",
	"./senha.svg": "3ad3",
	"./seta-baixo.svg": "5ed9",
	"./site.svg": "5358",
	"./stop.svg": "f669",
	"./switch.svg": "2bfe",
	"./tela-cheia.svg": "a7f3",
	"./telefone.svg": "a483",
	"./telegram.svg": "0a9c",
	"./texto.svg": "cf8e",
	"./troca.svg": "e716",
	"./upload-nuvem.svg": "2235",
	"./upload.svg": "e13c",
	"./usuario.svg": "8634",
	"./visualizar.svg": "70a2",
	"./voltar.svg": "bed8",
	"./whatsapp.svg": "8390",
	"./word.svg": "e582"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05cc";